import { render, staticRenderFns } from "./RentPaidReport.vue?vue&type=template&id=58db3683&scoped=true"
import script from "./RentPaidReport.vue?vue&type=script&lang=js"
export * from "./RentPaidReport.vue?vue&type=script&lang=js"
import style0 from "./RentPaidReport.vue?vue&type=style&index=0&id=58db3683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db3683",
  null
  
)

export default component.exports